import React, { useState, useEffect } from 'react';
import { Modal, Box, SpaceBetween, Button } from '@cloudscape-design/components';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function PaymentRequiredModal() {
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();
  const { trialStatus } = useAuth();

  useEffect(() => {
    // Show modal only for 'warning' state (≤ $7.50)
    if (trialStatus.needsPayment === 'warning') {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [trialStatus.needsPayment]);

  const handleAddPayment = () => {
    navigate('/payment-setup');
  };

  if (!visible) {
    return null;
  }

  return (
    <Modal
      visible={visible}
      onDismiss={() => setVisible(false)}
      header="Enjoying Recapify?"
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="link" onClick={() => setVisible(false)}>
              Remind Me Later
            </Button>
            <Button variant="primary" onClick={handleAddPayment}>
              Add Payment Method
            </Button>
          </SpaceBetween>
        </Box>
      }
    >
      <Box>
        You're making good use of Recapify! You'll soon need to add a payment method to continue. Add one now for seamless, uninterrupted access.
        <br /><br />
        <strong>What you need to know:</strong>
        <ul>
          <li>You can still use your remaining trial credits</li>
          <li>You'll only be charged for usage after your trial credits are fully consumed</li>
          <li>Pay-per-use pricing with monthly invoices</li>
          <li>No commitments - cancel anytime</li>
        </ul>
      </Box>
    </Modal>
  );
}

export default PaymentRequiredModal;
